const BaseModule = require('../../90_utils/base/BaseModule');

class GradientShape extends BaseModule {

	constructor(el, params) {

		super(el);

		this.startColor;
		this.endColor;
		this.$shape;
		this.$gradient;
		this.$gradientStops;
	}

	// basemodule methods

	_domReady(){

		this.$shape = this.$el.find('.svg');
		this.$gradient = this.$shape.find('#gradient');
		this.$gradientStops = this.$gradient.find('stop');

		if(isNaN(window.SETTINGS.vars.svgIndex)){ window.SETTINGS.vars.svgIndex = 0; }
		else { window.SETTINGS.vars.svgIndex++; }

		let gradientId = window.SETTINGS.vars.svgIndex;
		this.$gradient.attr('id', 'gradient' + gradientId);
		this.$shape.find('path').attr('fill', 'url(#gradient' + gradientId + ')');

		this._domUpdate();
		this.color();
	}

	_addListeners(){ }
	_removeListeners(){ }

	_show(){ }
	_hide(){ }

	_enable(){ }
	_disable(){ }

	_domUpdate(){

		this.startColor = this.checkVal(this.$el.data('gradient-start-color'), '#25c4f6');
		this.endColor = this.checkVal(this.$el.data('gradient-end-color'), '#f6379a');

	}
	_resize(){}

	//

	color(){
		// console.log(this.startColor, this.endColor, this.$shape, this.$gradient, this.$gradientStops);
		this.$gradientStops.eq(0).attr('stop-color', this.startColor);
		this.$gradientStops.eq(1).attr('stop-color', this.endColor);
	}
}

module.exports = GradientShape;
